import React, {useRef, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import {Breadcrumbs, Btn, H5} from "../../../../../AbstractElements";
import ParticipantForm from "../Component/Form";
import SearchOptions from "../../../../CommonComponents/Search";
import ParticipantsTable from "../Component/ParticipantsTable";
import {Participant, ParticipantTableRef} from "../../Types/ParticipantTypes";

const ParticipantIndex = () => {
    const [params, setParams] = useState<Record<string, unknown>>({});
    const [participantModalVisibility, setParticipantModalVisibility] = useState(false);
    const [searchVisibility, setSearchVisibility] = useState<boolean>(false);
    const searchOptions = [
        {name: 'name'},
        {name: 'collector_name', label: 'Collector'},
        {name: 'contact', label: 'Mobile'},
        {name: 'nic'}
    ];

    const participantTableRef = useRef<ParticipantTableRef>(null);

    const participantModalToggle = () => {
        setParticipantModalVisibility(!participantModalVisibility);
    };

    const addParticipant = (participant: Participant) => {
        if (participantTableRef.current) {
            participantTableRef.current.addParticipant(participant);
        }
        participantModalToggle();
    };

    const getParticipants = () => {
        if (participantTableRef.current) {
            participantTableRef.current.getParticipants();
        }
    };

    return (
        <div>
            <Breadcrumbs mainTitle="Participants" parent="Application" title="Participants"/>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Participants</H5>
                                <div className='d-flex align-items-center gap-2'>
                                    <ButtonIcon attrBtn={{onClick: () => setParticipantModalVisibility(true)}}
                                                type={'add'} permission={'create-participant'}/>
                                    <ButtonIcon attrBtn={{onClick: getParticipants}}
                                                type={'sync'} permission={'read-participant'}/>
                                    <ButtonIcon attrBtn={{onClick: () => setSearchVisibility(!searchVisibility)}}
                                                type={'search'} permission={'read-participant'}/>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {searchVisibility && (
                                    <SearchOptions
                                        callBack={(searchParams: Record<string, unknown>) => setParams(searchParams)}
                                        searchOptions={searchOptions}
                                    />
                                )}
                                <ParticipantsTable ref={participantTableRef} params={params}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={participantModalVisibility} toggle={participantModalToggle} centered>
                <ModalHeader>Create Participant</ModalHeader>
                <ModalBody>
                    <ParticipantForm callBack={addParticipant}/>
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{color: 'primary', onClick: participantModalToggle}}>Close</Btn>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ParticipantIndex;
